import React, { Component }  from 'react';
import * as requestLib from '../lib/requestLib'

export default class Footer extends Component {
    constructor(props) {
        super(props);

        this.state = {

        };

        this.baseUrl = requestLib.getUrl();

    }


    render() {

        let style =
            {
                position : this.props.posiNone === true ? 'absolute' : 'fixed'
            }

        return (
            <footer style={style}>
                <div className="left">
                    <h5>MIMICUS PRO</h5>
                    <h6>© 2018 HomoMimicus co., Ltd.</h6>
                </div>
                <div className="right">
                    <ul>
                        <li><a href={this.baseUrl + "Termsofuse"}>Terms of Use</a></li>
                        <li><a href={this.baseUrl + "Privacypolicy"}>Privacy policy</a></li>
                    </ul>
                </div>
            </footer>
        );
    }
}





// WEBPACK FOOTER //
// ./src/components/Footer.js